import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { PreventionProvider } from '../features/prevention/PreventionStore';
import { MobileBusinessProvider } from '../features/mobile/MobileBusinessStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

export function AppProviders({ children }: PropsWithChildren) {
  return <QueryClientProvider client={queryClient}><PreventionProvider><MobileBusinessProvider>{children}</MobileBusinessProvider></PreventionProvider></QueryClientProvider>;
}
